/**
 * Default home route after login for PSO-linked accounts.
 * Head and Regional Head open Request Form first instead of the dashboard.
 */
export function getPostLoginHomePathForPso(pso: { designation?: string } | null | undefined): string {
    if (!pso?.designation) return '/dashboard';
    const designation = String(pso.designation).replace(/_/g, ' ');
    const isProtocolOfficer = designation.toLowerCase().trim() === 'protocol officer';
    if (isProtocolOfficer) return '/protocols';
    const isInchargeHR = designation.toLowerCase().trim() === 'incharge hr';
    if (isInchargeHR) return '/travelling-approval';
    const isRegional = /regional/i.test(designation);
    const isHead = /(^|\s)head(\s|$)/i.test(designation) && !isRegional;
    if (isHead || isRegional) return '/request-summary';
    return '/dashboard';
}
